<template>
    <div>
        <v-row justify="center" class="mt-16">
            <v-col cols="12">
                <p class="text-center explanatory_text">
                    ログアウトしました。
                </p>
            </v-col>
        </v-row>
        <v-row justify="center" class="my-4">
            <v-col cols="3">
                <button-component block href="/documents/login">再ログイン</button-component>
            </v-col>
        </v-row>
        <v-row justify="center">
            <v-col class="cols-auto text-center" cols="6" >
                <div class="text--primary text-small text-center my-1">
                    締結した書類の確認は管理画面よりいつでも確認いただけます。
                </div>
            </v-col>
        </v-row>
        <br>
        <br>
        <v-divider></v-divider>
        <v-row justify="center" class="my-4">
            <v-col class="cols-auto text-center" cols="6" >
                <v-card color="#F4FEFB" style="height:100%; display: inline-block;">
                    <v-card-text class="text-center">
                        <v-btn color="blue" class="white--text" href="/">サービスサイトへ</v-btn>
                        <br>
                        <div class="text--primary text-small text-center my-4">
                            ※サービスサイトのURLをブックマークしておく事をおすすめいたします。
                        </div>
                    </v-card-text>
                </v-card>
            </v-col>
        </v-row>
    </div>
</template>

<script>
    export default {
    }
</script>

<style scoped>
    .password_reset_link a:hover {
        text-decoration-line: underline;
    }
    .explanatory_text {
        font-size: 18px;
    }
</style>